import React, { useEffect, useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import portfolio from "../data/portfolio.json";

const { navLinks } = portfolio;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div
          className={`flex items-center justify-between rounded-2xl px-5 py-3 transition-all duration-500 ${
            scrolled ? "glass-strong" : "bg-transparent"
          }`}
        >
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-2 group"
          >
            <div className="relative w-9 h-9 rounded-xl bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-teal-300/40 transition-colors">
              <Sparkles className="w-4 h-4 text-teal-300" />
              <div className="absolute -inset-px rounded-xl bg-teal-300/0 group-hover:bg-teal-300/5 transition" />
            </div>
            <span className="font-display font-semibold text-white tracking-tight">
              robertandros<span className="text-teal-300">.</span>dev
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(link.href);
                }}
                className="px-4 py-2 text-sm text-zinc-400 hover:text-white transition-colors rounded-lg hover:bg-white/5"
              >
                {link.name}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Button
              onClick={() => handleNav("#contact")}
              className="bg-teal-300 text-zinc-950 hover:bg-teal-200 font-medium"
            >
              Get in touch
            </Button>
          </div>

          <button
            onClick={() => setMobileOpen((s) => !s)}
            className="md:hidden p-2 rounded-lg hover:bg-white/5 text-white"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden mt-2 glass-strong rounded-2xl p-4 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(link.href);
                }}
                className="block px-4 py-3 text-zinc-300 hover:text-white hover:bg-white/5 rounded-lg"
              >
                {link.name}
              </a>
            ))}
            <Button
              onClick={() => handleNav("#contact")}
              className="w-full mt-2 bg-teal-300 text-zinc-950 hover:bg-teal-200"
            >
              Get in touch
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
